import { useSelector } from "react-redux";

import { selectCurrentProject, selectProjects } from "../../../core/data/redux/projects/selectors";

import type { ProjectCallerRole } from "../../../core/data/redux/projects/types";

import {
  PROJECT_CAPABILITIES,
  type ProjectCapability,
} from "../constants/projects.constants";

export const useProjectRole = (
  projectId?: number | string | null,
): ProjectCallerRole => {
  const currentProject = useSelector(selectCurrentProject);
  const projects = useSelector(selectProjects);

  if (!projectId) {
    return currentProject?.current_user_role ?? null;
  }

  const numericId = Number(projectId);
  if (currentProject && Number(currentProject.id) === numericId) {
    return currentProject.current_user_role ?? null;
  }

  const match = projects.find((p) => Number(p.id) === numericId);
  return match?.current_user_role ?? null;
};

export const useProjectCapability = (
  projectId: number | string | null | undefined,
  capability: ProjectCapability,
): boolean => {
  const role = useProjectRole(projectId);
  if (!role) return false;
  if (role === "SYSTEM_ADMIN") return true;
  const allowed = PROJECT_CAPABILITIES[capability] as readonly string[];
  return allowed.includes(role);
};
